"use client";

import { sendGTMEvent } from "@/components/Analytics";
import Button from "@/components/Cards/Button";
import Card from "@/components/Cards/Card";
import Slider from "@/components/Carousel/Slider";
import PlayerInPage from "@/components/Player/PlayerInPage";
import SideBySideText from "@/components/Text/SideBySideText";
import Testimonial from "@/components/Text/Testimonial";
import Text from "@/components/Text/Text";
import Title from "@/components/Text/Title";
import Triangles from "@/components/Triangles";
import { LongButton } from "@/stories/Button.stories";
import { CardIconSm, CardMdNoButton, TextCard } from "@/stories/Card.stories";
import { TestimonialYellow } from "@/stories/Testemonial.stories";
import Link from "next/link";

const symptomes = [
    {
        title: "Burnout",
        content:
            "Ein Burnout ist eine massive emotionale und körperliche Erschöpfung, die nicht primär durch die Arbeitsbelastung oder das Engagement verursacht wird, sondern vielmehr durch die Art und Weise, wie damit umgegangen wird.",
        img: "/images/symptoms1.png",
    },
    {
        title: "Überforderung",
        content:
            "Überforderung ist das Ergebnis eines Kräfteverhältnisses zwischen der eigenen Stärke und den Anforderungen der Situation. Größere Stärke verhindert Überforderung, während geringere Stärke sie fördert - ein einfaches Verhältnis.",
        img: "/images/symptoms2.png",
    },
    {
        title: "Depression",
        content:
            "Du fühlst dich antriebslos. Am Morgen hast du Mühe aufzustehen. Du beginnst auszuweichen, fühlst dich nicht mehr wohl, wirst vielleicht auch ein wenig schwermütig.",
        img: "/images/symptoms3.png",
    },
];
const stats = [
    {
        number: "8'000+",
        text: "Menschen begleitet",
        img: "/images/iconPeople.svg",
    },
    {
        number: "25 Jahre+",
        text: " Erfahrung",
        img: "/images/iconCheck.svg",
    },
    {
        number: "40'000+",

        text: "Einzelgespräche",
        img: "/images/iconConvo.svg",
    },
];
const eineChance = [
    {
        title: "Ich arbeite da, wo du nicht kannst",
        content:
            "Viele Blockaden kannst du durch Selbstfürsorge lösen. Manchmal gibt es aber auch Gründe, warum du dich selbst nicht unterstützen kannst. In diesen Fällen arbeite ich gezielt an den Ursachen im Energiefeld, die du nicht alleine lösen kannst.",
        img: "/images/chance1.png",
    },
    {
        title: "Bist du bereit für Veränderung?",
        content:
            "Energiefelder spielen eine entscheidende Rolle, wenn wir uns nachhaltig und langfristig verändern wollen. Allzu oft verfällt eine Veränderung in alte Muster und bleibt nur ein Strohfeuer. Darum repariere ich die Energiefelder, damit deine eigene Kraft und Selbstheilung gestärkt wird.",
        img: "/images/chance2.png",
    },
    {
        title: "Mehr Kraft für schwere Situationen",
        content:
            "Wenn man stärker ist, intakte Energiefelder hat, kann man Probleme besser lösen und mit Situationen umgehen, mit denen man vorher überfordert gewesen ist oder die man vermieden hat. Mit mehr Kraft macht das Leben einfach mehr Spass!",
        img: "/images/chance3.png",
    },
];
export default function WoHilftDieFernbehandlungLayout() {
    return (
        <>
            <div className="bg-blue flex justify-center ">
                <div className="container px-3 md:px-20 lg:pt-10 lg:px-10 pb-24 flex-col justify-center items-center gap-6 inline-flex">
                    <Title
                        hasPreTitle={true}
                        preTitle="Worum geht’s: WO DIE FERNBEHANDLUNG HELFEN KANN"
                        title="An den Ursachen arbeiten, um das Leben zu verändern"
                        hasSubTitle={false}
                        paddings="px-3 pt-24 "
                        textWidth=" max-w-3xl mx-auto"
                        text="Du drehst dich solange im Kreis, bis deine Energiefelder funktionieren. Dann hast du wieder Zugang zu deinem Leben."
                    />
                    <PlayerInPage
                        videoId="d41bfb8dcf1bf118d7d9f62dec21a81e"
                        thumbnail="/images/thumbnails/woHiliftThumbnail1.jpg"
                    />
                </div>
            </div>
            <div className="bg-blue">
                <Triangles backgroundColor="bg-yellow" buttomToTop={false} />
            </div>
            <div className="bg-yellow  flex justify-center">
                <div className="container   w-full  px-3 md:px-5 lg:px-16  flex-col justify-center items-center gap-6 lg:inline-flex">
                    <Testimonial
                        backgroundColor={TestimonialYellow.args?.backgroundColor}
                        differentTextColor={"text-red"}
                        hasImage={false}
                        text={
                            "Burnout, Ängste, Hochsensibilität, Depressionen, Unsicherheiten etc. haben alle etwas gemeinsam: Sie beschreiben den Zustand und nicht die Ursache."
                        }
                        icon={TestimonialYellow.args?.icon}
                        textColor={TestimonialYellow.args?.textColor}
                        name={TestimonialYellow.args?.name}
                        hasDescription={true}
                        wordsInDifferentColor={["beschreiben", "den", "Zustand"]}
                        description="Der Spezialist für die Instandsetzung menschlicher Energiefelder"
                    />
                </div>
            </div>

            <div className="bg-yellow">
                <Triangles backgroundColor="bg-white" buttomToTop={true} />
            </div>
            <div className="bg-white flex justify-center lg:py-20">
                <div className="container w-full px-3 py-10 flex-col justify-center items-center gap-6 inline-flex">
                    <SideBySideText
                        reverse={true}
                        paddings=""
                        backgroundColor="bg-white "
                        elementLeft={
                            <div className="text-center pt-5">
                                <PlayerInPage
                                    videoId="3139169dce14721b44eae1e89e90a05d"
                                    thumbnail="/images/thumbnails/woHiliftThumbnail2.jpg"
                                />
                            </div>
                        }
                        elementRight={
                            <Text
                                hasText={false}
                                title="Warum ich an Ursachen arbeite"
                                hasSubTitle={true}
                                subTitle="und nicht an Symptomen"
                                paddings="px-3 "
                                titleSize="text-xl3 lg:text-[80px]"
                                subTitleSize=" lg:text-xl3 text-xl"
                                leading="leading-9 lg:leading-[80px]"
                            />
                        }
                    />
                </div>
            </div>
            <div className="bg-white">
                <Triangles backgroundColor="bg-pink" buttomToTop={false} />
            </div>
            <div className="bg-pink w-full px-auto px-3   py-8 pt-30 flex-col  gap-6 inline-flex">
                <div className=" text-left pl-4 lg:pl-0 md:text-center lg:text-center text-black text-xl3 leading-9 lg:text-5xl font-bold  ">
                    Einige Symptome aus meinem Praxisalltag
                </div>
            </div>

            <div className="bg-pink">
                <div className="container px-10">
                    <div className="lg:hidden bg-pink">
                        <Slider
                            slideContnent={symptomes}
                            contentEl={CardMdNoButton}
                            slidesToShow={1}
                        />
                    </div>
                    <div className="hidden lg:block bg-pink">
                        <Slider
                            slideContnent={symptomes}
                            contentEl={CardMdNoButton}
                            paginationColor="black"
                            slidesToShow={3}
                        />
                    </div>
                </div>
            </div>

            <div className="bg-pink">
                <Triangles backgroundColor="bg-blue" buttomToTop={true} />
            </div>
            <div className="bg-blue w-full px-3 md:px-10 lg:px-20 py-20 flex-col justify-center items-center gap-6 inline-flex">
                <div className="lg:flex space-y-5 lg:space-y-0 md:gap-2  lg:justify-between text-center gap-6">
                    {stats.map((stat) => (
                        <div key={stat.text}>
                            <Card
                                backgroundColor="bg-blue"
                                border={CardIconSm.args?.border}
                                buttonPlacement={CardIconSm.args?.buttonPlacement}
                                hasButton={CardIconSm.args?.hasButton}
                                titleSize={CardIconSm.args?.titleSize}
                                width={CardIconSm.args?.width}
                                height={CardIconSm.args?.height}
                                hasImage={CardIconSm.args?.hasImage}
                                imgSrc={stat.img}
                                title={stat.number}
                                content={stat.text}
                                imageSize={CardIconSm.args?.imageSize}
                                contentSize={CardIconSm.args?.contentSize}
                                textSize={CardIconSm.args?.textSize}
                            />
                        </div>
                    ))}
                </div>
            </div>

            <div className="bg-blue">
                <Triangles backgroundColor="bg-white" buttomToTop={false} />
            </div>
            <div className="bg-white w-full lg:pt-30 px-3 lg:px-20 py-10 flex-col justify-center items-center gap-3 inline-flex">
                <div className=" text-left pl-2 lg:pl-0 lg:text-center text-black text-xl3 lg:text-5xl font-bold  leading-8 lg:leading-14">
                    Eine Chance auf Veränderung
                </div>
            </div>
            <div className="bg-white">
                <div className="container px-10">
                    <div className="lg:hidden bg-white py-20">
                        <Slider
                            slideContnent={eineChance}
                            contentEl={CardMdNoButton}
                            slidesToShow={1}
                        />
                    </div>
                    <div className="hidden lg:block bg-white">
                        <Slider
                            slideContnent={eineChance}
                            contentEl={CardMdNoButton}
                            paginationColor="fff"
                            slidesToShow={3}
                        />
                    </div>
                </div>
            </div>
            <div className="bg-white">
                <Triangles backgroundColor="bg-black" buttomToTop={true} />
            </div>
            <div className="bg-black w-full  lg:py-30 px-3 lg:px-20 py-20 flex-col justify-center items-center gap-6 inline-flex">
                <div>
                    <Card
                        backgroundColor={TextCard.args?.backgroundColor}
                        border={TextCard.args?.border}
                        content={TextCard.args?.content}
                        contentSize={TextCard.args?.contentSize}
                        hasImage={TextCard.args?.hasImage}
                        hasButton={TextCard.args?.hasButton}
                        width={TextCard.args?.width}
                        height={TextCard.args?.height}
                        title={TextCard.args?.title}
                        titleSize={TextCard.args?.titleSize}
                        textSize={TextCard.args?.textSize}
                        pretitle={TextCard.args?.pretitle}
                        hasPretitle={TextCard.args?.hasPretitle}
                        titlePlacement={TextCard.args?.titlePlacement}
                        textColor={TextCard.args?.textColor}
                        pretitleSize={TextCard.args?.pretitleSize}
                    />
                </div>
            </div>
            <div className="bg-black">
                <Triangles backgroundColor="bg-yellow" buttomToTop={false} />
            </div>
            <div className="bg-yellow w-full lg:py-30 px-3 md:px-20 lg:px-20 flex-col justify-center items-center gap-6 inline-flex">
                <div className="px-3 py-25 lg:px-96 lg:space-y-2 lg:py-25 md:px-20">
                    <div className="self-stretch text-center text-black text-xl3 lg:text-5xl font-bold  leading-10 lg:leading-14">
                        Du suchst nach einer Unterstützung?
                    </div>
                    <div className="w-full text-center text-black text-lg lg:text-xl1 lg:px-10 font-normal  leading-7 lg:leading-8.5">
                        Veränderung ist nur durch Stärke möglich und dazu braucht es
                        funktionierende Energiefelder. Einfach mal ausprobieren dank der
                        <span className="underline">
                            <Link href={"/de/30-tage-geld-zuruck-garantie"}>
                                {" "}
                                30-Tage-Geld-zurück-Garantie.
                            </Link>
                        </span>
                    </div>
                    <div className="flex justify-center py-4">
                        <Button
                            backgroundColor={LongButton.args?.backgroundColor}
                            textColor={LongButton.args?.textColor}
                            text={"Jetzt buchen"}
                            textSize={LongButton.args?.textSize}
                            paddings={"py-4 lg:px-14 px-10"}
                            rounded={LongButton.args?.rounded}
                            size={LongButton.args?.size}
                            border={LongButton.args?.border}
                            as="a"
                            href="/de/bestellen"
                            onClick={() => {
                                sendGTMEvent({
                                    event: "cta_click",
                                    section_title: "Du suchst nach einer Unterstützung?",
                                    section_index: "8",
                                    cta_text: "Jetzt buchen",
                                    cta_link: `${process.env.NEXT_PUBLIC_URL}/de/bestellen`,
                                });
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="bg-yellow">
                <Triangles backgroundColor="bg-darkGray" buttomToTop={true} />
            </div>
        </>
    );
}
